<!--仓库管理 - 领料单列表 详情-->
<template>
  <div>
    <el-row>
      <el-col>
        <el-col>
          <el-table :data="tableData" border stripe style="margin-top: 20px" @selection-change="handleSelectionChange">
            <el-table-column type="index" label="序号" width="50"></el-table-column>
            <el-table-column prop="PRODUCT_CODE" label="产品编码"></el-table-column>
            <el-table-column prop="PRODUCT_NAME" label="产品名称"></el-table-column>
            <el-table-column prop="TYPE_UNIT" label="单位"></el-table-column>
            <el-table-column prop="PRODUCT_BATCH" label="产品批次"></el-table-column>
            <el-table-column prop="LOCATION_CODE" label="库位" v-if="warehouseMode == 2"></el-table-column>
            <el-table-column prop="PRICE" label="价格"></el-table-column>
            <el-table-column prop="BEFORE_TAX_PRICE" label="不含税价格" min-width="45"></el-table-column>
            <el-table-column prop="TAX_RATE" label="税率" min-width="45"></el-table-column>
            <el-table-column prop="PRODUCT_COUNT" label="领料数量"></el-table-column>
            <el-table-column prop="PRODUCT_COMMENT" label="备注"></el-table-column>
            <el-table-column prop="RETURN_COUNT" label="退货数量"></el-table-column>
            <el-table-column prop="RETURN_REASON" label="退货原因"></el-table-column>
            <!-- <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button @click="openReturn(scope.row)" type="text">退货</el-button>
              </template>
            </el-table-column> -->
            <el-table-column type="selection"></el-table-column>
          </el-table>
        </el-col>
      </el-col>
      <el-col>
        <el-button @click="openReturn" style="float: right;margin: 10PX 0 0 10px">批量退货</el-button>
        <!-- <el-button @click="toPrintTable" style="float: right;margin-top: 10px">打印</el-button>
        <el-button @click="toShortPrintTable" style="float: right;margin-top: 10px">短打印</el-button> -->
        <el-button @click="print('打印')" style="float: right;margin-top: 10px">打印</el-button>
        <el-button @click="print('短打印')" style="float: right;margin-top: 10px">短打印</el-button>
      </el-col>
      <el-col>
      </el-col>
    </el-row>
    <el-dialog title="退货" center :visible.sync="returnDialogVisible" width="1300px">
      <!-- <el-form :model="returnForm" ref="returnForm">
        <el-form-item label="产品名称：" :label-width="formLabelWidth">
          <span>{{ returnForm.PRODUCT_NAME }}</span>
        </el-form-item>
        <el-form-item label="退货数量：" :label-width="formLabelWidth">
          <el-input v-model="returnForm.RETURN_COUNT"></el-input>
        </el-form-item>
        <el-form-item label="退货原因：" :label-width="formLabelWidth">
          <el-input v-model="returnForm.RETURN_REASON"></el-input>
        </el-form-item>
      </el-form> -->
      <el-table :data="returnList">
        <el-table-column type="index" label="序号" width="50"></el-table-column>
        <el-table-column prop="PRODUCT_CODE" label="产品编码"></el-table-column>
        <el-table-column prop="PRODUCT_NAME" label="产品名称"></el-table-column>
        <el-table-column prop="TYPE_UNIT" label="单位"></el-table-column>
        <el-table-column prop="PRODUCT_BATCH" label="产品批次"></el-table-column>
        <el-table-column prop="PRICE" label="价格"></el-table-column>
        <el-table-column prop="PRODUCT_COMMENT" label="备注"></el-table-column>
        <el-table-column prop="PRODUCT_COUNT" label="领料数量"></el-table-column>
        <el-table-column prop="RETURN_COUNT" label="已退数量"></el-table-column>
        <el-table-column prop="NEW_RETURN_COUNT" label="退货数量" min-width="130">
          <template slot-scope="scope">
            <el-input size="small" v-model="scope.row.NEW_RETURN_COUNT"
              :placeholder="`最多可退${scope.row.PRODUCT_COUNT - scope.row.RETURN_COUNT}${scope.row.TYPE_UNIT}`" clearable
              @change="checkNewReturnCount(scope.row)">
            </el-input>
          </template>
        </el-table-column>
        <el-table-column prop="NEW_RETURN_REASON" label="退货原因" min-width="100">
          <template slot-scope="scope">
            <el-input size="small" v-model="scope.row.NEW_RETURN_REASON" clearable>
            </el-input>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close">取 消</el-button>
        <el-button @click="submitReturn">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="是否打印编码" center :visible.sync="previewVisible" width="400px">
      <el-radio style="margin: 0px 80px 0 90px" v-model="IsPrintCode" label="1">是</el-radio>
      <el-radio v-model="IsPrintCode" label="0">否</el-radio>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeAll">取 消</el-button>
        <el-button @click="preview">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getDocDetailFun, pickingDocBatchReturn } from 'api/pickingManage';
import { print } from 'api/warehouseManager';

export default {
  data() {
    return {
      tableData: [],
      searchForm: {},
      departmentList: [],
      pickerOptions: [],
      titleData: [],
      returnDialogVisible: false,
      returnForm: {},
      formLabelWidth: '100px',
      companyName: '',
      isDisplay: 'none',
      returnList: [],
      IsPrintCode: '0',
      previewVisible: false,
      printType: '',
      isDisplayCode: '',
      warehouseMode: sessionStorage.getItem('WAREHOUSE_MODE'),
    };
  },
  created() {
    this.queryData();
    this.titleData = JSON.parse(sessionStorage.getItem('titleData'));
    this.companyName = sessionStorage.getItem('company');
    if (sessionStorage.getItem('tcId') == 4097) {
      this.isDisplay = 'flex';
    }
  },
  methods: {
    queryData() {
      const params = {
        ORDER_ID: Number(sessionStorage.getItem('orderID')),
      };
      getDocDetailFun(params).then((res) => {
        this.tableData = res;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    openDetail() {
      this.$router.push({ name: 'pickingDocDetail' });
    },
    openReturn() {
      if (this.returnList.length == 0) {
        this.$message.show({ text: '请选择要退货的产品', type: 'warning' });
        return false;
      }
      this.returnDialogVisible = true;
    },
    checkNewReturnCount(row) {
      const reg1 = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/;
      const reg2 = /^[+]{0,1}[1-9](\d*)$/;
      if (this.$util.JudgmentUnit(row.TYPE_UNIT)) {
        if (!reg1.test(row.NEW_RETURN_COUNT)) {
          this.$message.show({ text: '请输入正数退货数量', type: 'warning' });
          return false;
        }
      } else {
        if (!reg2.test(row.NEW_RETURN_COUNT)) {
          this.$message.show({ text: '请输入正整数退货数量', type: 'warning' });
          return false;
        }
      }
      if (row.NEW_RETURN_COUNT > row.PRODUCT_COUNT - row.RETURN_COUNT) {
        this.$message.show({ text: '总退货数量不得大于领料数量', type: 'warning' });
        return false;
      }
    },
    submitReturn() {
      const params = {
        ORDER_ID: Number(sessionStorage.getItem('orderID')),
        RETURN_LIST: this.returnList.map((item) => ({ ORDER_DETAIL_ID: item.ORDER_DETAIL_ID, RETURN_COUNT: Number(item.NEW_RETURN_COUNT), RETURN_REASON: item.NEW_RETURN_REASON ? item.NEW_RETURN_REASON : '' })),
      };
      pickingDocBatchReturn(params).then((res) => {
        this.returnDialogVisible = false;
        this.$message.show({ text: '退货成功', type: 'success' });
        this.queryData();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    close() {
      this.returnDialogVisible = false;
    },
    // 打印
    print(type) {
      this.previewVisible = true;
      this.printType = type;
    },
    closeAll() {
      this.previewVisible = false;
    },
    // 供应商客户打印
    preview() {
      this.isDisplayCode = '';
      if (this.printType == '打印') {
        if (this.IsPrintCode == '0') {
          this.isDisplayCode = 'none';
        }
        this.toPrintTable();
      } else if (this.printType == '短打印') {
        this.toShortPrintTable();
      }
    },
    toPrintTable() {
      let html = '<div>';
      html += '<div class="main" >';
      html += `<div class="title">${this.companyName}领料单</div>`;
      html += `<div class="head" style="font-size: 20px;"><div class="code" style="font-size: 20px;">领料单ID：${this.titleData.ID}</div><div class="code">领料人：${this.titleData.REQUISITIONER}</div><div>领料部门：${this.titleData.DEPARTMENT_NAME}</div></div>`;
      html += `<div class="head" style="font-size: 20px;"><div class="code" style="font-size: 20px;">领料日期：${this.titleData.SEND_DAY}</div></div>`;
      html += '<table border="1" cellspacing="0" style="position:relative; width:98%;"><div class="el-table__body el-table__header">';
      html += `<tr style="text-align: center"><td style="width: 40px">序号</td><td style="display:${this.isDisplayCode}">产品编码</td> <td>产品</td> <td>单位</td> <td  style="width: 40px">单价</td> <td style="width: 70px">库位</td><td style="width: 70px">领料数量</td> <td  style="width: 70px">领料金额</td> <td>备注</td> </tr>`;
      html += '</div><div class="el-table__body">';
      this.tableData.forEach((item, index) => {
        html += '<tr style="text-align: center;font-size: 14px">';
        html += `<td> ${index + 1} </td> <td style="display:${this.isDisplayCode}">${item.PRODUCT_CODE}</td> <td>${item.PRODUCT_NAME}</td><td>${item.TYPE_UNIT}</td><td>${item.PRICE}</td><td>${item.LOCATION_CODE}</td>
                        <td>${item.PRODUCT_COUNT}</td> <td>${(item.PRODUCT_COUNT * item.PRICE).toFixed(2)} </td> <td>${item.PRODUCT_COMMENT}</td>`;
        html += '</tr>';
      });
      html += '</div>';
      html += `<div class="divTop" style="font-size:12px; right:1%; flex-direction: column; position:absolute; page-break-after: always; position: fixed;  top: 250px; display:${this.isDisplay}">`;
      html += '<span style="font-size:15px">白</span>';
      html += '<span style="font-size:15px">联</span>';
      html += '<span style="font-size:15px">财</span>';
      html += '<span style="font-size:15px">务</span>';
      html += '<div style="height:5px;"> </div>';
      html += '<span style="font-size:15px">红</span>';
      html += '<span style="font-size:15px">联</span>';
      html += '<span style="font-size:15px">存</span>';
      html += '<span style="font-size:15px">根</span>';
      html += '<div style="height:5px;"></div>';
      html += '<span style="font-size:15px">黄</span>';
      html += '<span style="font-size:15px">联</span>';
      html += '<span style="font-size:15px">领</span>';
      html += '<span style="font-size:15px">料</span>';
      html += '</div>';
      html += '</table>';
      html += `<div style="margin-top: 20px; display: flex; justify-content: space-between ; flex-direction: row; font-size: 16px;"><div style=" font-size: 16px;">领料总金额：${this.tableData.reduce((total, item) => total += item.PRODUCT_COUNT * item.PRICE, 0).toFixed(2)}</div></div>`;
      html += `<div style="margin-top: 20px; display: flex; flex-direction: row; font-size: 16px;"><div style="font-size: 16px;">制单人：${this.titleData.CREATE_NAME}</div><div  style="margin-left: 120px; font-size: 16px;">领料人：</div><div style="margin-left: 120px; font-size: 16px;">部门主管：</div><div style="margin-left: 120px; font-size: 16px;">发料人：</div></div>`;

      html += '</div>';
      html += '</div>';
      const windows = print(html);
      windows.close();
    },
    // 短打印
    toShortPrintTable() {
      this.$router.push({ name: 'pickingOutShortPrint' });
      sessionStorage.setItem('IsPrintCode', this.IsPrintCode);
      sessionStorage.setItem('领料单创建人', this.titleData.CREATE_NAME);

    },
    handleSelectionChange(val) {
      this.returnList = val;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/warehouseManage/pickingDocDetail.vue